module.exports = __webpack_public_path__ + "static/img/icon2-4.6b2e2207.svg";